import { FC } from 'react';

import { useTranslate } from 'hooks/useTranslate';

import { Communication } from 'types';

import { TablePagination } from 'modules/_shared/Table/components/TablePagination';
import EmptyStateCard from 'modules/_shared/components/EmptyStates/EmptyStateCard';

import { useCommunicationsPage } from '../context/CommunicationsPageContext';
import CommunicaionsListRow from './CommunicationsListRow';

const CommunicationsList: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useCommunicationsPage();

  const hasData = data.totalCommunications > 0;
  const showPagination = data.totalCommunications > 10;

  return (
    <>
      {hasData ? (
        data.communications?.map(
          (communication: Communication, index: number) => (
            <div key={`comm-row-${communication._id}`} className="inbox-item">
              <CommunicaionsListRow
                index={index}
                communication={communication}
              />
            </div>
          )
        )
      ) : (
        <EmptyStateCard
          mainMessage={t('NoCommunicationsMessage')}
          infoMessage={t('NoCommunicationsInfoMessage')}
          bordered={false}
        />
      )}

      {showPagination && (
        <div className="mx-2">
          <TablePagination
            defaultPage={data.page}
            totalRows={data.totalCommunications || 0}
            showRowsPerPageOptions={false}
            onChangePage={actions.handleChangePage}
          />
        </div>
      )}
    </>
  );
};

export default CommunicationsList;
